export type {ToggleProps} from './Toggle.interface';
export {Toggle} from './Toggle';